import { Box, Button, Typography } from '@mui/material';

import K2Logo from '../../assets/images/welcome-k2-logo.png';
import BackgroundImage from '../../assets/images/welcome-background-image.png';
import React from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  name: string | undefined;
  lastname: string | undefined;
  userDetails: {
    detailName: string;
    detailValue: number | undefined;
  }[];
}

const LayoutHeader = ({ name, lastname, userDetails }: Props) => {
  const { pathname } = useLocation()

  const activePage = pathname === '/home'

  return (
      <Box
        sx={{
          backgroundColor: '#65AAE1',
          display: 'flex',
          '@media(max-width:768px)': {
            flexDirection: 'column',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '172px',
            background: `linear-gradient(90deg, #65AAE1 0%, rgba(101, 170, 225, 0.96) 21.74%, rgba(101, 170, 225, 0.85) 31.06%, rgba(101, 170, 225, 0.72) 46.07%, rgba(101, 170, 225, 0.6) 84.89%, rgba(101, 170, 225, 0.24) 99.38%) ,url(${BackgroundImage})`,
            backgroundSize: 'cover',
            backgroundPositionX: '20%',
            backgroundRepeat: 'no-repeat',
            width: activePage ? '60%' : '100%',
            padding: '20px 56px',
            '@media(max-width:768px)': {
              gap: '0px',
              marginBottom: '0px',
              justifyContent: 'space-around',
              padding: '10px',
              width: '100%',
            },
          }}
        >
          <img
            src={K2Logo}
            alt='welcome-k2-logo'
            style={{
              maxWidth: activePage ? '64px' : '35px',
              opacity: '0.7',
            }}
          />
          <Typography
            fontSize={activePage ? '30px' : '24px'}
            fontWeight={'400'}
            lineHeight={activePage ? '36px' : '29px'}
            color={'rgba(255, 255, 255, 0.8)'}
            sx={{
              marginTop: '20px',
              '@media(max-width:768px)': {
                fontSize: '20px',
              },
            }}
          >
            Welcome, {name} {lastname}!
          </Typography>
        </Box>

        {activePage && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '40%',
              justifyContent:
                userDetails.length === 3
                  ? 'space-between'
                  : userDetails.length === 2
                  ? 'space-around'
                  : 'center',
              padding: '0px 20px',
              '@media(max-width:768px)': {
                justifyContent: 'center',
                width: '100%',
                padding: '0',
              },
            }}
          >
            {userDetails.map((detail, i) => (
              <React.Fragment key={i}>
                <>
                  <Box
                    key={i}
                    sx={{
                      maxWidth: activePage ? '124px' : '194px',
                      width: '100%',
                      padding: '16px',
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      fontSize={'16px'}
                      fontWeight={'500'}
                      lineHeight={'19px'}
                      color={'rgba(255, 255, 255, 0.8)'}
                      marginBottom={'12px'}
                      sx={{
                        '@media(max-width:768px)': {
                          fontSize: '12px',
                          lineHeight: '14px',
                        },
                      }}
                    >
                      {detail.detailName}
                    </Typography>
                    <Typography
                      fontSize={'48px'}
                      fontWeight={'400'}
                      lineHeight={'18px'}
                      color={'#fff'}
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '0 auto',
                        border: '2px solid rgba(255, 255, 255, 0.7)',
                        borderRadius: '50%',
                        width: '85px',
                        height: '85px',
                        '@media(max-width:768px)': {
                          width: '45px',
                          height: '45px',
                          fontSize: '28px',
                        },
                      }}
                    >
                      {detail.detailValue}
                    </Typography>
                  </Box>
                  {userDetails?.length - 1 !== i && (
                    <Box
                      sx={{
                        width: '2px',
                        height: '150px',
                        display: detail.detailValue === 0 ? 'none' : 'flex',
                        background:
                          ' linear-gradient(180deg, #E3DDE6 1.04%, #ACC7DC 27.6%, #BCCDE4 86.46%, #E3DDE6 98.44%)',
                        '@media(max-width:768px)': {
                          display: 'none',
                        },
                      }}
                    />
                  )}
                </>
              </React.Fragment>
            ))}
          </Box>
        )}
      </Box>
  );
};

export default LayoutHeader;
